import { useState } from "react";
import { toast } from "react-toastify";
import useAuthUserOtpVerify from "../../../../../../api/hooks/hooks-auth/use-auth-user-otp-verify";
import { transformPhone } from "../../../../../../lib/utils";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../../../shared/constants";

export interface ISignInData {
  numberPhone: string | null;
  otp: string | null;
}

export type ISignInDataKeys = keyof ISignInData;

const INITIAL_SIGNIN_DATA = {
  numberPhone: null,
  otp: null,
};

const useSignIn = () => {
  const [signInData, setSignInData] =
    useState<ISignInData>(INITIAL_SIGNIN_DATA);

  const handleChange = (key: ISignInDataKeys, data: string) => {
    setSignInData((prev) => {
      return { ...prev, [key]: data };
    });
  };

  const {
    data: token,
    error: authUserOtpVerifyError,
    isMutating: authUserOtpVerifyIsMutating,
    trigger: authUserOtpVerifyTrigger,
  } = useAuthUserOtpVerify();

  const handleSendData = async () => {
    if (signInData.numberPhone && signInData.otp) {
      try {
        await authUserOtpVerifyTrigger({
          phone: transformPhone(signInData.numberPhone),
          otpCode: signInData.otp,
        });

        toast.success("Вы авторизованы");
      } catch (error) {
        toast.error("Ошибка. Не удалось зарегистрироваться, проверьте данные.");
      }
    }
  };

  return { handleSignIn: handleSendData, handleChange, signInData, token };
};

export default useSignIn;
